import SimpleTextField from "../Forms/FieldTypes/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => {
  return {
    fontSize: {
      paddingTop: "3px",
    }
  };
});

export default function FontSize(props) {
  const {
    disabled = false,
    name = "fontSize",
    onChange,
    size,
    value,
    variant = "outlined",
  } = props;
  const classes = useStyles()

  return (
      <SimpleTextField
        classes={{root: classes.fontSize}}
        disabled={disabled}
        InputProps={{
          endAdornment: <InputAdornment position="end">pt</InputAdornment>,
          inputProps: {
            max: 40,
            min: 1,
          },
        }}
        name={name}
        onChange={onChange}
        size={size}
        type="number"
        value={value}
        variant={variant}
      />
  );
}
